<template>
    <CustomHeader :text="$t('activityName.recharge_gift')" :show-history="true" @openHistoryPopup="openHistoryPopup"
        :is-popup-close-back-icon="true" @closePopup="navToBack" />
    <div class="bg-back">
        <img class="bg-top-img" :src="dataSet.bannerIcon">
        <div class="container">
            <NoticeCard :content="formattedMessages" />
            <div v-if="dataSet.rechargeBonusStatus == 1" class="immidiateDepositBtn">
                <div class="depositBtn" @click="goToDeposit()"> {{ $t('activity.immediateDeposit') }}</div>
            </div>
            <div>
                <CashBackCard :title="$t('common.bets')" :create-date="dataSet.todayRechargeGiftDetails?.createTime"
                    :day="dataSet.todayRechargeGiftDetails?.day"
                    :available-value="dataSet.todayRechargeGiftDetails?.availableAmount"
                    :showClickButton="dataSet.todayRechargeGiftDetails?.availableAmount > 0"
                    :given-value="dataSet.todayRechargeGiftDetails?.givenAmount" @get-claim="getClaim"
                    :dayList="dataSet.futureRewards.length <= 0 ? getDefaultRewards(dayCount) : dataSet.futureRewards" />
            </div>

            <CashbackWeekDetails :bet-list="dataSet.weeklyRechargeGiftList" :title="$t('myDataView.totalRecharge')"
                :cashback-total="dataSet.cashbackTotal" type="RECHARGE"
                :istoday-claimed="dataSet.todayRechargeGiftDetails?.availableAmount > 0" />

            <CashbackHistoryPopup ref="histryPopupRef" @getHistoryList="getHistoryList" :list="dataSet.historyList"
                :title="$t('myDataView.totalRecharge')" @updateHistoryList="getNextPageRewardData"
                :showIcon="dataSet.total > dataSet.pageSize * dataSet.pageNum" @resetHistoryData="resetHistoryData" />
        </div>
    </div>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue';
import { getDefaultRewards } from '@/utils/commonFunction';
import { DAY_COUNT, RechargeGiftData } from '@/view/rechargeGift/supportScript';
import CustomHeader from '../components/common/customHeader.vue';
import { useRouter } from 'vue-router';
import NoticeCard from './components/noticeCard.vue';
import CashBackCard from './components/cashBackCard.vue';
import CashbackWeekDetails from './components/cashbackWeekDetails.vue';
import CashbackHistoryPopup from './components/cashbackHistoryPopup.vue';

const histryPopupRef = ref();

const dayCount = ref(DAY_COUNT)
const router = useRouter()
const props = defineProps<{
    dataSet: RechargeGiftData
}>()

const formattedMessages = computed(() =>
    props.dataSet.activityDescription.map(msg => msg.replace(/\\n/g, '\n'))
);

const emits = defineEmits(['getNextPageRewardData', 'getHistoryList', 'resetHistoryData', 'getClaim', 'goToDeposit'])

const getNextPageRewardData = () => {
    emits('getNextPageRewardData')
}
const getHistoryList = () => {
    emits('getHistoryList')
}

const resetHistoryData = () => {
    emits('resetHistoryData')
}
const openHistoryPopup = (data: any) => {
    histryPopupRef.value.open(data)
}
const goToDeposit = () => {
    emits("goToDeposit")
    localStorage.setItem('showDepositBackIcon', '1')
}
const getClaim = () => {
    emits('getClaim')
}
const navToBack = () => {
    router.go(-1)
}
</script>
<style scoped>
.bg-back {
    background: rgb(2, 74, 73);
    padding-bottom: 50px;
    background: linear-gradient(180deg, #66402100 0%, #001f1a 50%, #66402100 100%);
}

.container {
    padding: 0px;
    position: relative;

}

.container>>>.van-tabs__nav {
    background: transparent;
    padding: 0 15px;
}

.container>>>.van-tab {
    background: rgba(255, 255, 255, 0.04);
    color: rgba(255, 255, 255, 0.45);
    border-radius: 30px;
    font-size: 12px;
    margin: 5px;
    height: 35px;
    padding: 0 15px;
}

.container>>>.van-tab.van-tab--active {
    background-image: linear-gradient(180deg, #F8D8A7 0%, #F0A853 100%);
    color: #12151A;
    font-weight: 500;
}

.container>>>.van-tabs__line {
    background-color: transparent;
    height: 0px;
}

.content {
    color: #fff;
    padding: 15px;
}

.image-wrapper {
    position: relative;
    display: inline-block;
}

.bottom_text {
    padding: 0px 25px;
    margin-top: 25px;
}

.line1 {
    background-image: linear-gradient(90deg, rgba(255, 255, 255, 0.00) 0%, rgba(255, 255, 255, 0.65) 100%);
    border-radius: 1px;
    height: 2px;
    margin: 8px 0 0 0;
}

.line2 {
    transform: scaleX(-1);
    background-image: linear-gradient(90deg, rgba(255, 255, 255, 0.00) 0%, rgba(255, 255, 255, 0.65) 100%);
    border-radius: 1px;
    height: 2px;
    margin: 8px 0 0 0;
}

.title {
    color: rgba(255, 255, 255, 0.85);
    font-size: 15px;
    display: flex;
    justify-content: center;
}

.line_text {
    color: rgba(255, 255, 255, 0.45);
    font-size: 14px;
    padding: 10px;
}

.bg-top-img {
    width: 100%;
    padding-top: 3rem;
}

.arrowDown {
    display: flex;
    justify-content: center;

}

.arrowDown img {
    width: 25px;
    transform: rotate(-90deg);
    padding: 10px;
}

.immidiateDepositBtn {
    display: flex;
    justify-content: center;
    padding: 10px;
}

.depositBtn {
    color: #84b8a1;
    font-weight: bold;
    font-size: 18px;
    background: linear-gradient(90deg, #00302d 0%, #002725d9 50%, #043b31 100%);
    border-radius: 30px;
    padding: 10px;
    width: 90%;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    height: 30px;
    align-items: center;
    box-shadow: inset 4px 4px 12px rgb(17 117 119);
    cursor: pointer;
    text-transform: uppercase;
}
</style>